<template>
  <!-- 点标记dialog -->
  <v-dialog v-model="value" max-width="700" scrollable persistent>
    <v-card>
      <v-card-title>标记数据
        <v-spacer />
        <v-icon color="primary" class="mr-2" @click="$emit('input',false)">mdi-close</v-icon>
      </v-card-title>
      <v-card-text class="pb-8">
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th>name</th>
                <th>x</th>
                <th>y</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(point,index) in items" :key="index">
                <td>{{ point.name}}</td>
                <td>{{ point.x}}</td>
                <td>{{ point.y}}</td>
                <td align="right">
                  <a class="caption" @click="onDeleteSs(index)">取消</a>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ['value', 'items'],
  methods: {
    onDeleteSs (index) {
      this.$parent.onDeleteSs(index);
    }
  }
}
</script>